import {payoutSvg as Icon__small__payoutSvg} from '../Icon__small/Icon__small--payout.js'

export var payout = {
  name: 'payout',
  category: 'icon',
  colorable: true,
  svg: Icon__small__payoutSvg,
};
